const formats = [
  { icon: 'ri-calendar-check-line', title: 'Корпоративный тренинг', desc: 'Практическая программа для руководителей: диагностика, инструменты, разбор реальных ситуаций и отработка навыков.' },
  { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Несколько модулей с практикой между встречами. Руководители применяют инструменты в работе и возвращаются для разбора.' },
  { icon: 'ri-award-line', title: 'Управленческая программа', desc: 'Комплексное развитие руководителей на протяжении нескольких месяцев с закреплением результатов.' },
  { icon: 'ri-group-line', title: 'Фасилитация', desc: 'Помощь управленческой команде в обсуждении изменений, поиске решений и принятии согласованных договорённостей.' },
  { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Моделирование ситуаций, связанных с изменениями, сопротивлением и управленческими решениями.' },
  { icon: 'ri-user-voice-line', title: 'Коучинг руководителей', desc: 'Индивидуальная работа с конкретными ситуациями внедрения изменений и управленческими задачами.' },
  { icon: 'ri-user-heart-line', title: 'Сопровождение', desc: 'Поддержка руководителей во время внедрения изменений и разбор возникающих сложностей.' },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Форматы обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как развивать компетенции управления изменениями — формат подбирается под задачу компании
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}